import { useEffect } from "react";

import {
    WithAnalyticsEventsProps,
    withAnalyticsEvents
} from "@atlaskit/analytics-next";

import {
    useAnalyticsClient,
    useAnalyticsOptOut
} from "../wac-analytics/analytics-client";

import { AnalyticsData } from "./gasv3";
import { Initializer } from "./initializer";

export type InitializeAutoAtlAnalyticsProps = {
    readonly pageViewProperties?: AnalyticsData;
} & WithAnalyticsEventsProps;

const deepClone: <T extends object>(obj: T) => T = (obj) => {
    return JSON.parse(JSON.stringify(obj)) as typeof obj;
};

const InitializeAutoAtlAnalyticsImpl: React.FC<
    InitializeAutoAtlAnalyticsProps
> = ({
    pageViewProperties = {},
    createAnalyticsEvent
}: InitializeAutoAtlAnalyticsProps) => {
    const analyticsClient = useAnalyticsClient();
    const [analyticsOptOut] = useAnalyticsOptOut();
    const ANALYTICS_WRITE_KEY = process.env["ANALYTICS_SOURCE_ID"] || "";

    useEffect(() => {
        if (!analyticsClient || analyticsOptOut) {
            return;
        }
        Initializer.initWithPageAnalytics(
            ANALYTICS_WRITE_KEY,
            deepClone(pageViewProperties),
            {},
            Date.now(),
            analyticsClient.getAnonymousId(),
            createAnalyticsEvent || null
        );
    }, [analyticsClient]);

    return null;
};

export const InitializeAutoAtlAnalytics = withAnalyticsEvents()(
    InitializeAutoAtlAnalyticsImpl
);
